export enum EDeleteLocationUsersAction {
  NoAction,
  DeleteUsers,
  MoveUsers,
}
